export default __webpack_public_path__ + "static/media/hkkba_banner.000ef413.jpg";